import React from "react";
import { useNavigate } from "react-router-dom";

const Head = ({ heading, button_text, navigation }) => {
  return (
    <div className="flex justify-between">
      <p className="font-bold text-3xl text-secondary">{heading}</p>
      <button
        onClick={navigation}
        className={`button-primary ${
          heading === "Customer Payments" ||
          heading === "Journal Transaction" ||
          heading === "Monthly Voucher" ||
          heading === "Customer Voucher" ||
          heading === "Supplier Voucher" ||
          heading === "Accounts Voucher" ||
          heading === "Supplier Payments"
            ? "!w-[220px]"
            : ""
        }`}
      >
        {button_text}
      </button>
    </div>
  );
};

export default Head;
